<template>
  <div id="wx_login">
  </div>
</template>
<script>
import request from '../api/request'
import { WX_APPID, WX_LOGIN_CB } from '../define'

export default {
  created() {
    this.$store.dispatch('logged_in')
      .then(() => {
        this.$router.push('/')
      })
      .catch(() => {
        request.test.post('login').then(resp => {
          this.$store.commit('updateLogin', resp.data['acl'])
          this.$router.push('/')
        }).catch(() => {
          this.wxLogin()
        })
      })
  },
  methods: {
    wxLogin: function () {
      // eslint-disable-next-line
      new WxLogin({
        id: 'wx_login',
        self_redirect: true,
        appid: WX_APPID,
        scope: 'snsapi_login',
        response_type: 'code',
        state: new Date().getTime(),
        redirect_uri: WX_LOGIN_CB
      })
      window.wxOauthCb = (code) => {
        request.admin.post('login_wx', {
          code: code,
          appid: WX_APPID
        }).then(resp => {
          if (resp.data) {
            this.$store.commit('updateLogin', resp.data['acl'])
            this.$router.push('/')
          }
        })
      }
    }
  },
}
</script>
<style scoped>
#wx_login{
  text-align: center
}
</style>
